var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('NavigationBar'),_c('Breadcrumb',{attrs:{"breadcrumbText":"About Us"}}),_c('History'),_c('Feedback'),_c('Team'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }